/**
 * Teaming Global Components
 */
import { Socket } from "vue-loading-spinner";
import FontAwesomeIcon from "@/lib/FontAwesomeIcon";

const GlobalComponents = {
	install( Vue ) {
		Vue.component( "socket", Socket );
		Vue.component( "font-awesome-icon", FontAwesomeIcon );
	},
};

export default GlobalComponents;



// WEBPACK FOOTER //
// ./src/globalComponents.js